<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- <div class="row">
        <div class="col-sm-8">
            <b-form-select @change="getAllSubs()" v-model="selectedStatus" :options="payoutStatus" class="mb-3" />
        </div>
    </div> -->
    <div v-if="nSubs" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Merchant Accounts</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="nSubs"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(name)="data">
                <div>
                  <span>{{ data.value }}</span><br />
                  <span style="font-size: 10px; color:blue;">{{ data.item.reseller }}</span>
                </div>
              </template>
              <template #cell(id)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <router-link
                tag="button"
                :to="{
                  path: '/stores',
                  query: { merchId: data.value },
                }"
                class="btn btn-primary btn-rounded"
              >
                Stores
              </router-link>
              <router-link
                tag="button"
                :to="{
                  path: '/merchant-details',
                  query: { merchId: data.value },
                }"
                class="btn btn-secondary btn-rounded"
              >
                More
              </router-link>
              <i v-if="hardwareCompanies.includes(data.value)" class="bx bx-devices" style="color: #f9be00;">Renting Hardware</i>
        <!-- <a :href="`#${data.value.replace(/[^a-z]+/i,'-').toLowerCase()}`">{{ data.value }}</a> -->
      </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import firebase from 'firebase/app';

export default {
    page: {
    title: "Merchants",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
    components: {
    Layout,
    PageHeader,
  },
  data(){
      return {
          title: "Merchants",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Merchants",
          active: true,
        },
      ],
      fields: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "email",
          sortable: true,
        },
        {
          key: "devices",
          sortable: false,
        },
        {
          key: "isSubscribed",
          sortable: true,
        },
        {
          key: "isOnTrial",
          sortable: true,
        },
        {
          key: "number",
          sortable: true,
        },
        {
          key: "country",
          sortable: true,
        },
        {
          key: "subEnd",
          sortable: true,
        },
        {
          key: "created",
          sortable: true,
        },
        {
          key: "id",
          sortable: false
        }
      ],
      hardwareCompanies: [],
      options: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      nSubs: [],
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      pageOptions: [10, 25, 50, 100],
      isLoading: false,
      fullPage: true,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      filter: null,
      filterOn: [],
      resellers: []
      }
  },
  methods: {
    async startupStuff(){
      await this.getAllResellers();
    await this.getAllSubs();
    },
    async getAllResellers(){
      await firebase.firestore().collection("users").where("isReseller", "==", true).get().then((allData)=>{

        allData.docs.forEach((rData)=>{
          var data = {
            id: rData.id,
            name: rData.data().name
        }
        this.resellers.push(data);
        })
        
      })
    },
    markAsHardware(merchId){
        // eslint-disable-next-line no-console
        // console.log("merchId ", merchId)
        var isIncluded = this.hardwareCompanies.includes(merchId);
        this.$bvModal
        .msgBoxConfirm(isIncluded == true ? "Remove from hardware company list ?": "Add as company with hardware ?")
        .then(async (value)=>{
            if(value == true){
                // eslint-disable-next-line no-console
                console.log("test");
                await firebase.firestore().collection("globalSettings")
                .doc("hardwareMerchants").update({
                    merchants: isIncluded == true ?
                    firebase.firestore.FieldValue.arrayRemove(merchId):
                    firebase.firestore.FieldValue.arrayUnion(merchId)
                }).then(()=>{
                    location.reload();
                })
            }
        })
    },
    async getHardwareData(){
        await firebase.firestore().collection("globalSettings")
        .doc("hardwareMerchants").get().then((data)=>{
            this.hardwareCompanies = data.data().merchants;
        })
    },
      onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getAllSubs(){
        this.nSubs = [];
      await firebase.firestore().collection("users")
      .where("isMerchant", "==", true)
      .orderBy("created", "desc")
    //   .where("status", "==", this.selectedStatus)
      .get().then((dataList)=>{
        // eslint-disable-next-line no-console
                        // console.log(this.selectedStatus);
        if(dataList.size > 0){
          var itemArray = [];
          dataList.docs.forEach((singleDoc)=>{
            var resellerData = singleDoc.data().reseller ?? null;
            if(resellerData != null){
              resellerData = this.resellers.find(element => element.id == resellerData);
            }
            var data = {
              id: singleDoc.id,
              created: singleDoc.data().created.toDate().toLocaleDateString("en-US", this.options),
              email: singleDoc.data().email,
              country: singleDoc.data().country,
              isEnabled: singleDoc.data().isEnabled,
              isMerchant: singleDoc.data().isMerchant,
              isOnTrial: singleDoc.data().isOnTrial == true ? "YES": "NO",
              isSubscribed: singleDoc.data().isSubscribed == true ? "YES": "NO",
              isVerified: singleDoc.data().isVerified,
              name: singleDoc.data().name,
              number: singleDoc.data().number ?? null,
              subEnd: singleDoc.data().subEnd ? singleDoc.data().subEnd.toDate().toLocaleDateString("en-US", this.options) : "n/a",
              devices: singleDoc.data().connectedDevices ? singleDoc.data().connectedDevices.length : 0,
              reseller: resellerData?.name ?? null
            }
            itemArray.push(data);
            this.nSubs = itemArray
          })
        }
      })
      await this.getHardwareData();
    }
  },
  computed: {
      rows() {
      return this.nSubs.length;
    },
  },

  mounted() {
    this.startupStuff();
  },
}
</script>

<style>

</style>